<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-application-view">
    <vs-alert color="danger" title="Application Not Found" :active.sync="not_found">
      <span>Application record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'application.list'}" class="text-inherit underline">All
        Applications</router-link>
      </span>
    </vs-alert>

    <vs-row v-if="data">
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-4">{{ data.ApplicationName }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <div class="vx-card p-4">
              <application-view-details :data="data_local" />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col>
            <div class="vx-card p-4">
              <application-view-uri-details
                  v-if="!data_local.IsDeleted"
                  :value="data_local" />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <vs-col>
            <div class="vx-card p-4">
              <application-view-token-details
                  v-if="data_local.ExternalIdentity"
                  :value="data_local" />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <div class="vx-row" v-if="data">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              v-if="data.IsDeleted == 0 && componentAccess.canDelete.access"
              @click="deleteApplication" class="my-4" >
            Delete
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              v-if="data.IsDeleted == 0 && componentAccess.canEdit.access"
              @click="edit"
              color="light"
              class="my-4">Edit</vs-button>
          
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import ApplicationViewDetails from "@/views/pages/applications/view/ApplicationViewDetails";
import ApplicationViewUriDetails from "@/views/pages/applications/view/ApplicationViewUriDetails";
import ApplicationViewTokenDetails from "@/views/pages/applications/view/ApplicationViewTokenDetails";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  components: {
    ApplicationViewDetails,
    ApplicationViewUriDetails,
    ApplicationViewTokenDetails
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      data: null,
      not_found: false,
      data_local: null,
      componentAccess: {
        canEdit: {
          route: 'application.edit',
          access: false,
        },
        canDelete: {
          route: 'application.delete',
          access: false,
        },
      }
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async fetch(applicationId) {
      try {
        this.data = null;
        const { data } = await this.$api.applications.get(applicationId, { params: {'include' : 'roles'} });
        const application = data.data;

        if (!application.ExternalIdentity
          || !application.ExternalIdentity.allowed_origins) {
          application.ExternalIdentity =
              {
                ...application.ExternalIdentity,
                allowed_origins: [],
              }
        }

        this.data = application;
        this.data_local = JSON.parse(JSON.stringify(application))
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    },
    edit() {
      this.$router.push({ name: 'application.edit', params: { id: this.data.id }}).catch(() => {})
    },
    deleteApplication() {
      const deleteRecord = async () => {
        try {
          await this.$api.applications.delete(this.id);
          this.$router.push({ name: 'application.list'}).catch(() => {})
        } catch(e) {
          console.log(e);
        }
      }

      const message = "Warning: this operation is not reversible. Please confirm deletion of this role. "
                  + "If a record is deleted in error please contact Furness IT Support. "
                  + "Are you sure you want to delete this application?";

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: message,
        accept: deleteRecord,
        acceptText: 'Delete',
      })
    }
  },

  created () {
    this.fetch(this.$route.params.id)
  }
}

</script>
